// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActorDto } from './IClaimActorDto';
import {
    IClaimActorDtoFromJSON,
    IClaimActorDtoFromJSONTyped,
    IClaimActorDtoToJSON,
    IClaimActorDtoToJSONTyped,
} from './IClaimActorDto';

/**
 * 
 * @export
 * @interface IClaimApprovalStatusDto
 */
export interface IClaimApprovalStatusDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimApprovalStatusDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimApprovalStatusDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimApprovalStatusDto
     */
    claim_approval_status_type?: IClaimApprovalStatusDtoClaimApprovalStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimApprovalStatusDto
     * @deprecated
     */
    claim_approval_status_code?: IClaimApprovalStatusDtoClaimApprovalStatusCodeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IClaimApprovalStatusDto
     */
    claim_approval_status_codes?: Array<IClaimApprovalStatusDtoClaimApprovalStatusCodesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IClaimApprovalStatusDto
     */
    custom_denial_reason?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimApprovalStatusDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimApprovalStatusDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {IClaimActorDto}
     * @memberof IClaimApprovalStatusDto
     */
    claim_actor?: IClaimActorDto;
    /**
     * 
     * @type {number}
     * @memberof IClaimApprovalStatusDto
     */
    approved_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimApprovalStatusDto
     */
    initially_processed_incorrectly?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IClaimApprovalStatusDtoClaimApprovalStatusTypeEnum {
    PENDING_REVIEW = 'PENDING_REVIEW',
    UNDER_REVIEW = 'UNDER_REVIEW',
    DOCS_NEEDED = 'DOCS_NEEDED',
    INCOMPLETE = 'INCOMPLETE',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    CANCELLED = 'CANCELLED',
    VOIDED = 'VOIDED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimApprovalStatusDtoClaimApprovalStatusCodeEnum {
    EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES',
    EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES',
    SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD = 'SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD',
    CLAIM_RECEIVED_AFTER_RUNOUT_DATE = 'CLAIM_RECEIVED_AFTER_RUNOUT_DATE',
    CLAIM_SUBMITTED_AFTER_GRACE_PERIOD = 'CLAIM_SUBMITTED_AFTER_GRACE_PERIOD',
    DUPLICATE_CLAIM = 'DUPLICATE_CLAIM',
    PROOF_OF_EXPENSE_NEEDED = 'PROOF_OF_EXPENSE_NEEDED',
    LETTER_OF_MEDICAL_NECESSITY_REQUIRED = 'LETTER_OF_MEDICAL_NECESSITY_REQUIRED',
    DETAILED_RECEIPT_REQUIRED = 'DETAILED_RECEIPT_REQUIRED',
    ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION = 'ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION',
    ADDITIONAL_COMMENTS = 'ADDITIONAL_COMMENTS',
    CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR = 'CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED = 'AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT',
    CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR = 'CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED',
    AUTOMATICALLY_APPROVED_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED = 'AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED',
    AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE',
    AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE',
    CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS = 'CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS',
    CLAIM_SUBMITTED_AFTER_DEADLINE = 'CLAIM_SUBMITTED_AFTER_DEADLINE',
    MEDICAL_EXPENSE_NOT_ELIGIBLE = 'MEDICAL_EXPENSE_NOT_ELIGIBLE',
    ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE = 'ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE',
    AMOUNT_NEEDED = 'AMOUNT_NEEDED',
    DATE_OF_SERVICE_NEEDED = 'DATE_OF_SERVICE_NEEDED',
    DATE_RANGE_OF_CARE_NEEDED = 'DATE_RANGE_OF_CARE_NEEDED',
    DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD = 'DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD',
    DOCUMENT_NOT_READABLE = 'DOCUMENT_NOT_READABLE',
    HANDWRITTEN_RECEIPT_NOT_SUFFICIENT = 'HANDWRITTEN_RECEIPT_NOT_SUFFICIENT',
    MERCHANT_NEEDED = 'MERCHANT_NEEDED',
    SERVICE_DESCRIPTION_NEEDED = 'SERVICE_DESCRIPTION_NEEDED',
    SERVICE_FOR_NEEDED = 'SERVICE_FOR_NEEDED',
    AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE = 'AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE',
    CUSTOM = 'CUSTOM',
    AUTOMATICALLY_APPROVED_BY_SIGIS = 'AUTOMATICALLY_APPROVED_BY_SIGIS',
    AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST = 'AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST',
    APPEAL_NOTE = 'APPEAL_NOTE'
}
/**
* @export
* @enum {string}
*/
export enum IClaimApprovalStatusDtoClaimApprovalStatusCodesEnum {
    EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES',
    EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES',
    SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD = 'SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD',
    CLAIM_RECEIVED_AFTER_RUNOUT_DATE = 'CLAIM_RECEIVED_AFTER_RUNOUT_DATE',
    CLAIM_SUBMITTED_AFTER_GRACE_PERIOD = 'CLAIM_SUBMITTED_AFTER_GRACE_PERIOD',
    DUPLICATE_CLAIM = 'DUPLICATE_CLAIM',
    PROOF_OF_EXPENSE_NEEDED = 'PROOF_OF_EXPENSE_NEEDED',
    LETTER_OF_MEDICAL_NECESSITY_REQUIRED = 'LETTER_OF_MEDICAL_NECESSITY_REQUIRED',
    DETAILED_RECEIPT_REQUIRED = 'DETAILED_RECEIPT_REQUIRED',
    ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION = 'ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION',
    ADDITIONAL_COMMENTS = 'ADDITIONAL_COMMENTS',
    CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR = 'CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED = 'AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT',
    CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR = 'CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED',
    AUTOMATICALLY_APPROVED_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED = 'AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED',
    AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE',
    AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE',
    CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS = 'CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS',
    CLAIM_SUBMITTED_AFTER_DEADLINE = 'CLAIM_SUBMITTED_AFTER_DEADLINE',
    MEDICAL_EXPENSE_NOT_ELIGIBLE = 'MEDICAL_EXPENSE_NOT_ELIGIBLE',
    ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE = 'ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE',
    AMOUNT_NEEDED = 'AMOUNT_NEEDED',
    DATE_OF_SERVICE_NEEDED = 'DATE_OF_SERVICE_NEEDED',
    DATE_RANGE_OF_CARE_NEEDED = 'DATE_RANGE_OF_CARE_NEEDED',
    DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD = 'DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD',
    DOCUMENT_NOT_READABLE = 'DOCUMENT_NOT_READABLE',
    HANDWRITTEN_RECEIPT_NOT_SUFFICIENT = 'HANDWRITTEN_RECEIPT_NOT_SUFFICIENT',
    MERCHANT_NEEDED = 'MERCHANT_NEEDED',
    SERVICE_DESCRIPTION_NEEDED = 'SERVICE_DESCRIPTION_NEEDED',
    SERVICE_FOR_NEEDED = 'SERVICE_FOR_NEEDED',
    AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE = 'AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE',
    CUSTOM = 'CUSTOM',
    AUTOMATICALLY_APPROVED_BY_SIGIS = 'AUTOMATICALLY_APPROVED_BY_SIGIS',
    AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST = 'AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST',
    APPEAL_NOTE = 'APPEAL_NOTE'
}


/**
 * Check if a given object implements the IClaimApprovalStatusDto interface.
 */
export function instanceOfIClaimApprovalStatusDto(value: object): value is IClaimApprovalStatusDto {
    return true;
}

export function IClaimApprovalStatusDtoFromJSON(json: any): IClaimApprovalStatusDto {
    return IClaimApprovalStatusDtoFromJSONTyped(json, false);
}

export function IClaimApprovalStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimApprovalStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'claim_approval_status_type': json['claim_approval_status_type'] == null ? undefined : json['claim_approval_status_type'],
        'claim_approval_status_code': json['claim_approval_status_code'] == null ? undefined : json['claim_approval_status_code'],
        'claim_approval_status_codes': json['claim_approval_status_codes'] == null ? undefined : json['claim_approval_status_codes'],
        'custom_denial_reason': json['custom_denial_reason'] == null ? undefined : json['custom_denial_reason'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'claim_actor': json['claim_actor'] == null ? undefined : IClaimActorDtoFromJSON(json['claim_actor']),
        'approved_amount': json['approved_amount'] == null ? undefined : json['approved_amount'],
        'initially_processed_incorrectly': json['initially_processed_incorrectly'] == null ? undefined : json['initially_processed_incorrectly'],
    };
}

export function IClaimApprovalStatusDtoToJSON(json: any): IClaimApprovalStatusDto {
    return IClaimApprovalStatusDtoToJSONTyped(json, false);
}

export function IClaimApprovalStatusDtoToJSONTyped(value?: IClaimApprovalStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claim_id': value['claim_id'],
        'claim_approval_status_type': value['claim_approval_status_type'],
        'claim_approval_status_code': value['claim_approval_status_code'],
        'claim_approval_status_codes': value['claim_approval_status_codes'],
        'custom_denial_reason': value['custom_denial_reason'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'claim_actor': IClaimActorDtoToJSON(value['claim_actor']),
        'approved_amount': value['approved_amount'],
        'initially_processed_incorrectly': value['initially_processed_incorrectly'],
    };
}

